<template>
  <div>
    <div class="ncLogin local-nc-track"
         ref="track"
         @mousedown.prevent="startDrag"
         @touchstart.prevent="startDrag">
      <div class="local-nc-bg"
           :style="{ width: offsetX + handleWidth + 'px' }"></div>
      <div class="local-nc-text">{{ passed ? "验证通过" : "请按住滑块，拖动到最右边" }}</div>
      <div class="local-nc-handle"
           :class="{ passed: passed }"
           :style="{ transform: 'translateX(' + offsetX + 'px)' }">
        {{ passed ? "✓" : ">" }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['scene'],
  data() {
    return {
      nc: null,
      passed: false,
      dragging: false,
      startX: 0,
      startOffset: 0,
      offsetX: 0,
      handleWidth: 40
    }
  },
  mounted() {
    this.validationFun()
  },
  beforeDestroy() {
    this.removeDragEvents()
  },
  methods: {
    validationFun(params) {
      this.nc = {
        reload: this.reset,
        reset: this.reset
      }
    },
    getClientX(event) {
      return event.touches && event.touches.length ? event.touches[0].clientX : event.clientX
    },
    getMaxOffset() {
      const track = this.$refs.track
      if (!track) return 0
      return Math.max(track.clientWidth - this.handleWidth, 0)
    },
    startDrag(event) {
      if (this.passed) return
      this.dragging = true
      this.startX = this.getClientX(event)
      this.startOffset = this.offsetX
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag, { passive: false })
      document.addEventListener('touchend', this.stopDrag)
    },
    onDrag(event) {
      if (!this.dragging) return
      event.preventDefault()
      const distance = this.getClientX(event) - this.startX
      const maxOffset = this.getMaxOffset()
      this.offsetX = Math.min(Math.max(this.startOffset + distance, 0), maxOffset)
      if (this.offsetX >= maxOffset) {
        this.pass()
      }
    },
    stopDrag() {
      if (!this.dragging) return
      this.dragging = false
      this.removeDragEvents()
      if (!this.passed) {
        this.offsetX = 0
      }
    },
    removeDragEvents() {
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
    },
    pass() {
      if (this.passed) return
      const nc_token = ['LOCAL', new Date().getTime(), Math.random()].join(':')
      this.passed = true
      this.dragging = false
      this.offsetX = this.getMaxOffset()
      this.removeDragEvents()
      this.$emit('validationData', {
        ncToken: nc_token,
        csessionid: nc_token,
        sig: nc_token,
        scene: this.scene
      })
    },
    refresh() {
      this.reset()
    },
    reset() {
      this.removeDragEvents()
      this.passed = false
      this.dragging = false
      this.offsetX = 0
    }
  }
}
</script>

<style lang="less" scoped>
.ncLogin {
}
.local-nc-track {
  position: relative;
  //width: 300px;
  max-width: 100%;
  height: 40px;
  overflow: hidden;
  border: 1px solid #dcdfe6;
  background: #f5f7fa;
  box-sizing: border-box;
  user-select: none;
}
.local-nc-bg {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #d1f0d3;
}
.local-nc-text {
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 38px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}
.local-nc-handle {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  background: #ffffff;
  border-right: 1px solid #dcdfe6;
  color: #909399;
  cursor: pointer;
  box-sizing: border-box;
}
.local-nc-handle.passed {
  color: #19be6b;
}
</style>



// WEBPACK FOOTER //
// src/components/login/slidingValidation.vue